import Title from "../../components/common/title/Title";
import { useEffect, useState, useCallback } from "react";
import { PiArrowDownBold, PiTrash, PiPlus } from "react-icons/pi";
import { getApi, postApi } from "../../services/api/globalApi";
import * as XLSX from "xlsx";
import AffiliateRankCard from "./sub-components/Affiliates";
import CampaignRefExceptions from "./sub-components/CampaignRefExceptions";
import { successMessage } from "../../utils/toastify-message/ToastifyMessage";
import Button from "../../components/common/button/Button";
import ProductsSelect from "../../components/common/inputs/ProductsSelect";
import DateInput from "../../components/common/inputs/DateInput";
import CategoriesSelect from "../../components/common/inputs/CategoriesSelect";
import AsyncSelect from "react-select/async";

export default function PublicFieldForm() {
  const [accardionToggle, setAccardionToggle] = useState({
    subMenu1: false,
    subMenu2: false,
    subMenu3: false,
    subMenu4: false,
    subMenu5: false,
    subMenu6: false,
    subMenu7: false,
    subMenu8: false,
    subMenu9: false,
  });

  const [data, setData] = useState({});
  const [affiliateLevelDiscountAttarbashi, setAffiliateLevelDiscountAttarbashi] = useState(true);
  const [affiliateLevelDiscountSaboora, setAffiliateLevelDiscountSaboora] = useState(true);
  const [campaignAttarbashiActive, setCampaignAttarbashiActive] = useState(false);
  const [campaignSabooraActive, setCampaignSabooraActive] = useState(false);
  const [campaignTargetMode, setCampaignTargetMode] = useState("all");
  const [campaignTiersAttarbashi, setCampaignTiersAttarbashi] = useState([]);
  const [campaignTiersSaboora, setCampaignTiersSaboora] = useState([]);
  const [sabooraShippingConfig, setSabooraShippingConfig] = useState([]);
  const [discountHiddenForRoles, setDiscountHiddenForRoles] = useState([]);
  const [discountHiddenUsers, setDiscountHiddenUsers] = useState([]);

  const getPublicFieldData = async () => {
    const path = "admin/publicFields";
    try {
      const data = await getApi({ path });
      setData(data?.data.result?.data?.[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPublicFieldData();
  }, []);

  useEffect(() => {
    const loadDataAndFetchCounts = async () => {
      if (data) {
        setAffiliateLevelDiscountAttarbashi(data?.activeAffilateLevelDiscount ?? true);
        setAffiliateLevelDiscountSaboora(data?.activeAffilateLevelDiscountSaboora ?? true);
        setCampaignAttarbashiActive(data?.activeCampaignAttarbashi ?? false);
        setCampaignSabooraActive(data?.activeCampaignSaboora ?? false);
        setCampaignTargetMode(data?.campaignTargetMode ?? "all");
        const allTiers = data?.campaignDiscountTiers || [];

        const fetchCountForTier = async (tier) => {
          if (tier.isOrderCountBased && tier.orderCountStartDate) {
            try {
              const path = `admin/publicFields/completed-order-count?startDate=${tier.orderCountStartDate}`;
              const response = await getApi({ path });
              return { ...tier, completedOrderCount: response?.data?.result || 0 };
            } catch (error) {
              console.log("Error fetching order count:", error);
              return tier;
            }
          }
          return tier;
        };

        const attarbashiTiersBase = allTiers
          .filter(tier => !tier.brand || tier.brand === 'attarbashi')
          .map((tier, idx) => ({
            ...tier,
            _tempId: tier._id || `loaded-attarbashi-${idx}-${Date.now()}`,
          }));

        const sabooraTiersBase = allTiers
          .filter(tier => tier.brand === 'saboora')
          .map((tier, idx) => ({
            ...tier,
            _tempId: tier._id || `loaded-saboora-${idx}-${Date.now()}`,
          }));

        const attarbashiTiersWithCounts = await Promise.all(
          attarbashiTiersBase.map(fetchCountForTier)
        );
        const sabooraTiersWithCounts = await Promise.all(
          sabooraTiersBase.map(fetchCountForTier)
        );

        setCampaignTiersAttarbashi(attarbashiTiersWithCounts);
        setCampaignTiersSaboora(sabooraTiersWithCounts);

        const shippingConfig = data?.sabooraShippingConfig || [];
        const groupedConfig = {};

        shippingConfig.forEach(item => {
          const key = `${item.shippingPrice}-${item.isDivisible}`;
          if (!groupedConfig[key]) {
            groupedConfig[key] = {
              shippingPrice: item.shippingPrice,
              isDivisible: item.isDivisible,
              skus: [],
              selectedProducts: []
            };
          }
          groupedConfig[key].skus.push(item.sku);
          groupedConfig[key].selectedProducts.push(item.sku);
        });

        const groupedArray = Object.keys(groupedConfig).map((key, idx) => ({
          ...groupedConfig[key],
          _tempId: `loaded-shipping-${idx}-${Date.now()}`
        }));

        setSabooraShippingConfig(groupedArray.length > 0 ? groupedArray : []);

        setDiscountHiddenForRoles(data?.discountHiddenForRoles || []);
        const userIds = data?.discountHiddenForUserIds || [];
        const userNames = data?.discountHiddenForUserNames || [];
        setDiscountHiddenUsers(
          userIds.map((id, i) => ({ value: id, label: userNames[i] || id }))
        );
      }
    };

    loadDataAndFetchCounts();
  }, [data]);

  const handleAddTierAttarbashi = () => {
    setCampaignTiersAttarbashi([
      ...campaignTiersAttarbashi,
      {
        _tempId: Date.now(),
        minPrice: 0,
        maxPrice: null,
        discountPercent: 0,
        isFreeShipping: false,
        hasGift: false,
        giftType: "fixed",
        giftProductSkus: [],
        additionalFixedGiftSkus: [],
        minPriceForGift: null,
        brand: "attarbashi",
        isOrderCountBased: false,
        minOrderCount: null,
        maxOrderCount: null,
        orderCountStartDate: null,
        isItemCountBased: false,
        minItemCount: null,
        maxItemCount: null,
        isPerUserOrderCountBased: false,
        perUserMinOrderCount: null,
        perUserMaxOrderCount: null,
        perUserOrderCountStartDate: null,
        perUserOrderCountEndDate: null,
        requiredUserLevels: [],
        requiredUserIds: [],
        roles: [],
        startDateTime: null,
        endDateTime: null,
        excludedCategories: [],
        excludedProductSkus: [],
        productGroupDiscounts: [],
      },
    ]);
  };

  const handleAddTierSaboora = () => {
    setCampaignTiersSaboora([
      ...campaignTiersSaboora,
      {
        _tempId: Date.now(),
        minPrice: 0,
        maxPrice: null,
        discountPercent: 0,
        isFreeShipping: false,
        hasGift: false,
        giftType: "fixed",
        giftProductSkus: [],
        additionalFixedGiftSkus: [],
        minPriceForGift: null,
        brand: "saboora",
        isOrderCountBased: false,
        minOrderCount: null,
        maxOrderCount: null,
        orderCountStartDate: null,
        isItemCountBased: false,
        minItemCount: null,
        maxItemCount: null,
        isPerUserOrderCountBased: false,
        perUserMinOrderCount: null,
        perUserMaxOrderCount: null,
        perUserOrderCountStartDate: null,
        perUserOrderCountEndDate: null,
        requiredUserLevels: [],
        requiredUserIds: [],
        roles: [],
        startDateTime: null,
        endDateTime: null,
        excludedCategories: [],
        excludedProductSkus: [],
        productGroupDiscounts: [],
      },
    ]);
  };

  const handleRemoveTierAttarbashi = (index) => {
    setCampaignTiersAttarbashi(campaignTiersAttarbashi.filter((_, i) => i !== index));
  };

  const handleRemoveTierSaboora = (index) => {
    setCampaignTiersSaboora(campaignTiersSaboora.filter((_, i) => i !== index));
  };

  const handleTierChangeAttarbashi = (index, field, value) => {
    const newTiers = [...campaignTiersAttarbashi];
    if (field === "giftProductSkus" || field === "additionalFixedGiftSkus") {
      newTiers[index][field] = Array.isArray(value) ? value : value.split(",").map((s) => s.trim()).filter(Boolean);
    } else if (field === "minPrice" || field === "maxPrice" || field === "discountPercent") {
      newTiers[index][field] = value === "" ? null : Number(value);
    } else if (field === "minOrderCount" || field === "maxOrderCount" || field === "minItemCount" || field === "maxItemCount" || field === "perUserMinOrderCount" || field === "perUserMaxOrderCount") {
      newTiers[index][field] = value === "" ? null : parseInt(value, 10);
    } else if (field === "isFreeShipping" || field === "hasGift" || field === "isOrderCountBased" || field === "isItemCountBased" || field === "isPerUserOrderCountBased") {
      newTiers[index][field] = value;
    } else if (field === "requiredUserLevels" || field === "requiredUserIds") {
      newTiers[index][field] = Array.isArray(value) ? value : [];
    } else {
      newTiers[index][field] = value;
    }
    setCampaignTiersAttarbashi(newTiers);
  };

  const handleTierChangeSaboora = (index, field, value) => {
    const newTiers = [...campaignTiersSaboora];
    if (field === "giftProductSkus" || field === "additionalFixedGiftSkus") {
      newTiers[index][field] = Array.isArray(value) ? value : value.split(",").map((s) => s.trim()).filter(Boolean);
    } else if (field === "minPrice" || field === "maxPrice" || field === "discountPercent") {
      newTiers[index][field] = value === "" ? null : Number(value);
    } else if (field === "minOrderCount" || field === "maxOrderCount" || field === "minItemCount" || field === "maxItemCount" || field === "perUserMinOrderCount" || field === "perUserMaxOrderCount") {
      newTiers[index][field] = value === "" ? null : parseInt(value, 10);
    } else if (field === "isFreeShipping" || field === "hasGift" || field === "isOrderCountBased" || field === "isItemCountBased" || field === "isPerUserOrderCountBased") {
      newTiers[index][field] = value;
    } else if (field === "requiredUserLevels" || field === "requiredUserIds") {
      newTiers[index][field] = Array.isArray(value) ? value : [];
    } else {
      newTiers[index][field] = value;
    }
    setCampaignTiersSaboora(newTiers);
  };

  const handleExcelUploadForTier = (index, handleChange) => async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = "";
    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const ws = workbook.Sheets[workbook.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const mobileColIndex = rows[0]?.findIndex(
          (h) => String(h).trim() === "موبایل" || String(h).trim() === "mobile"
        );
        if (mobileColIndex === -1) {
          alert("ستون «موبایل» در فایل یافت نشد");
          return;
        }
        const mobiles = rows
          .slice(1)
          .map((r) => String(r[mobileColIndex] || "").trim())
          .filter(Boolean);
        if (mobiles.length === 0) {
          alert("هیچ موبایلی در فایل یافت نشد");
          return;
        }
        const res = await postApi({
          path: "admin/users/lookup-by-mobiles",
          body: JSON.stringify({ mobiles }),
        });
        const found = res?.data?.result?.found || [];
        const notFound = res?.data?.result?.notFound || [];
        const userIds = found.map((u) => u.userId);
        handleChange(index, "requiredUserIds", userIds);
        const msg = `${found.length} کاربر بارگذاری شد` + (notFound.length ? ` | ${notFound.length} موبایل یافت نشد` : "");
        alert(msg);
      } catch (err) {
        console.error(err);
        alert("خطا در پردازش فایل اکسل");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleSaveTiers = async () => {
    const path = "admin/publicFields";
    const attarbashiToSave = campaignTiersAttarbashi.map(({ _tempId, ...tier }) => ({ ...tier, brand: 'attarbashi' }));
    const sabooraToSave = campaignTiersSaboora.map(({ _tempId, ...tier }) => ({ ...tier, brand: 'saboora' }));
    const allTiers = [...attarbashiToSave, ...sabooraToSave];
    const body = {
      campaignDiscountTiers: allTiers,
    };
    console.log("Saving tiers:", allTiers);
    try {
      await postApi({ path, body });
      successMessage("تنظیمات کمپین با موفقیت ذخیره شد");
      await getPublicFieldData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddSabooraShipping = () => {
    setSabooraShippingConfig([
      ...sabooraShippingConfig,
      {
        _tempId: Date.now(),
        skus: [],
        shippingPrice: 75000, // 75000 تومان
        isDivisible: false,
        selectedProducts: [],
      },
    ]);
  };

  const handleRemoveSabooraShipping = (index) => {
    setSabooraShippingConfig(sabooraShippingConfig.filter((_, i) => i !== index));
  };

  const handleSabooraShippingChange = (index, field, value) => {
    const newConfig = [...sabooraShippingConfig];
    if (field === "shippingPrice") {
      newConfig[index][field] = value === "" ? 0 : Number(value);
    } else if (field === "isDivisible") {
      newConfig[index][field] = value;
    } else if (field === "products") {

      const selectedSkus = Array.isArray(value) ? value : [];
      newConfig[index].skus = selectedSkus; 
      newConfig[index].selectedProducts = selectedSkus; 
    } else {
      newConfig[index][field] = value;
    }
    setSabooraShippingConfig(newConfig);
  };

  const handleSaveSabooraShipping = async () => {
    const path = "admin/publicFields";

    const configToSave = [];
    sabooraShippingConfig.forEach(group => {
      (group.skus || []).forEach(sku => {
        configToSave.push({
          sku: sku,
          shippingPrice: group.shippingPrice,
          isDivisible: group.isDivisible
        });
      });
    });

    const body = {
      sabooraShippingConfig: configToSave,
    };
    try {
      await postApi({ path, body });
      successMessage("تنظیمات پس کریه صبورا با موفقیت ذخیره شد");
      await getPublicFieldData();
    } catch (error) {
      console.log(error);
    }
  };

  const loadUsers = useCallback(async (inputValue) => {
    try {
      const [r1, r2, r3] = await Promise.all([
        getApi({ path: "admin/users", params: { limit: 20, searchText: inputValue || "", role: "affiliate" } }),
        getApi({ path: "admin/users", params: { limit: 20, searchText: inputValue || "", role: "seller" } }),
        getApi({ path: "admin/users", params: { limit: 20, searchText: inputValue || "", role: "customer" } }),
      ]);
      const all = [
        ...(r1?.data?.result?.data || []),
        ...(r2?.data?.result?.data || []),
        ...(r3?.data?.result?.data || []),
      ];
      return all.map((u) => ({
        value: u._id,
        label: u.name
          ? `${u.mobile || u.phoneNumber} - ${u.name} (${u.role === "affiliate" ? "نماینده" : u.role === "seller" ? "مشاور" : "مشتری"})`
          : u.mobile || u.phoneNumber,
      }));
    } catch { return []; }
  }, []);

  const handleSaveDiscountHiding = async () => {
    try {
      await postApi({
        path: "admin/publicFields",
        body: {
          discountHiddenForRoles,
          discountHiddenForUserIds: discountHiddenUsers.map((u) => u.value),
          discountHiddenForUserNames: discountHiddenUsers.map((u) => u.label),
        },
      });
      successMessage("تنظیمات مخفی‌سازی تخفیف ذخیره شد");
      await getPublicFieldData();
    } catch (error) { console.log(error); }
  };

  const handleAffiliateLevelDiscountAttarbashiToggle = async () => {
    const newStatus = !affiliateLevelDiscountAttarbashi;
    const path = "admin/publicFields";
    try {
      await postApi({ path, body: { activeAffilateLevelDiscount: newStatus } });
      setAffiliateLevelDiscountAttarbashi(newStatus);
      successMessage(`خدمات سطح عطارباشی با موفقیت ${newStatus ? 'فعال' : 'غیرفعال'} شد`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAffiliateLevelDiscountSabooraToggle = async () => {
    const newStatus = !affiliateLevelDiscountSaboora;
    const path = "admin/publicFields";
    try {
      await postApi({ path, body: { activeAffilateLevelDiscountSaboora: newStatus } });
      setAffiliateLevelDiscountSaboora(newStatus);
      successMessage(`خدمات سطح صبورا با موفقیت ${newStatus ? 'فعال' : 'غیرفعال'} شد`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCampaignAttarbashiToggle = async () => {
    const newStatus = !campaignAttarbashiActive;
    const path = "admin/publicFields";
    const body = {
      activeCampaignAttarbashi: newStatus,
    };
    try {
      await postApi({ path, body });
      setCampaignAttarbashiActive(newStatus);
      successMessage(`کمپین عطارباشی با موفقیت ${newStatus ? 'فعال' : 'غیرفعال'} شد`);
      await getPublicFieldData();
    } catch (error) {
      console.log(error);
    }
  };

  const handleCampaignTargetModeChange = async (newMode) => {
    const path = "admin/publicFields";
    try {
      await postApi({ path, body: { campaignTargetMode: newMode } });
      setCampaignTargetMode(newMode);
      successMessage(`حالت کمپین به «${newMode === "specific" ? "اختصاصی" : "عمومی"}» تغییر یافت`);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCampaignSabooraToggle = async () => {
    const newStatus = !campaignSabooraActive;
    const path = "admin/publicFields";
    const body = {
      activeCampaignSaboora: newStatus,
    };
    try {
      await postApi({ path, body });
      setCampaignSabooraActive(newStatus);
      successMessage(`کمپین صبورا با موفقیت ${newStatus ? 'فعال' : 'غیرفعال'} شد`);
      await getPublicFieldData();
    } catch (error) {
      console.log(error);
    }
  };

  const renderTier = (tier, index, handleRemove, handleChange) => (
    <div
      key={tier._tempId || tier._id || index}
      className="border border-gray-200 rounded-xl bg-white shadow-sm mb-4 overflow-hidden"
    >
      <div className="flex items-center justify-between px-4 py-2.5 bg-gradient-to-l from-slate-50 to-white border-b border-gray-100">
        <div className="flex items-center gap-2">
          <span className="w-5 h-5 rounded-full bg-slate-700 text-white text-xs font-bold flex items-center justify-center">
            {index + 1}
          </span>
          <span className="font-semibold text-sm text-slate-700">سطح {index + 1}</span>
        </div>
        <button
          onClick={() => handleRemove(index)}
          className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
        >
          <PiTrash size={16} />
        </button>
      </div>

      <div className="p-4 space-y-4">
        <div className="flex gap-3 flex-wrap">
          <div className="flex items-center justify-between flex-1 p-3 bg-blue-50/60 border border-blue-100 rounded-lg">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={tier.isOrderCountBased || false}
                onChange={(e) => handleChange(index, "isOrderCountBased", e.target.checked)}
                className="w-4 h-4 rounded"
              />
              <span className="text-sm font-semibold text-blue-700">
                سفارشات کل سیستم
              </span>
            </label>
            {tier.isOrderCountBased && tier.orderCountStartDate && (
              <span className="text-xs bg-green-100 text-green-700 px-2.5 py-1 rounded-full font-semibold whitespace-nowrap">
                {tier.completedOrderCount ?? "..."} سفارش
              </span>
            )}
          </div>

          <div className="flex items-center flex-1 p-3 bg-emerald-50/60 border border-emerald-100 rounded-lg">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={tier.isItemCountBased || false}
                onChange={(e) => handleChange(index, "isItemCountBased", e.target.checked)}
                className="w-4 h-4 rounded"
              />
              <span className="text-sm font-semibold text-emerald-700">
                تعداد قلم سبد خرید
              </span>
            </label>
          </div>

          <div className="flex items-center flex-1 p-3 bg-violet-50/60 border border-violet-100 rounded-lg">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={tier.isPerUserOrderCountBased || false}
                onChange={(e) => handleChange(index, "isPerUserOrderCountBased", e.target.checked)}
                className="w-4 h-4 rounded"
              />
              <span className="text-sm font-semibold text-violet-700">
                سفارشات شخصی کاربر
              </span>
            </label>
          </div>
        </div>

        {tier.isItemCountBased ? (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">حداقل تعداد قلم</label>
              <input
                type="number"
                value={tier.minItemCount ?? ""}
                onChange={(e) => handleChange(index, "minItemCount", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-400"
                placeholder="مثلاً 1"
                min="1"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">حداکثر تعداد قلم (خالی = بدون حد)</label>
              <input
                type="number"
                value={tier.maxItemCount ?? ""}
                onChange={(e) => handleChange(index, "maxItemCount", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-400"
                placeholder="مثلاً 5"
                min="1"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">درصد تخفیف</label>
              <input
                type="number"
                value={tier.discountPercent || ""}
                onChange={(e) => handleChange(index, "discountPercent", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-emerald-400"
              />
            </div>
          </div>
        ) : null}

        {tier.isPerUserOrderCountBased ? (
          <div className="border border-violet-200 rounded-xl p-3 bg-violet-50/30 space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <div>
                <label className="block text-xs text-gray-500 mb-1">حداقل سفارشات قبلی کاربر</label>
                <input
                  type="number"
                  value={tier.perUserMinOrderCount ?? ""}
                  onChange={(e) => handleChange(index, "perUserMinOrderCount", e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-violet-400"
                  placeholder="مثلاً 2"
                  min="0"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">حداکثر سفارشات قبلی (خالی = بدون حد)</label>
                <input
                  type="number"
                  value={tier.perUserMaxOrderCount ?? ""}
                  onChange={(e) => handleChange(index, "perUserMaxOrderCount", e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-violet-400"
                  placeholder="مثلاً 2"
                  min="0"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">درصد تخفیف</label>
                <input
                  type="number"
                  value={tier.discountPercent || ""}
                  onChange={(e) => handleChange(index, "discountPercent", e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-violet-400"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <DateInput
                label="شروع بازه شمارش سفارشات"
                value={tier.perUserOrderCountStartDate}
                onChange={(newDate) => handleChange(index, "perUserOrderCountStartDate", newDate)}
                showTime={true}
              />
              <DateInput
                label="پایان بازه شمارش سفارشات (خالی = اکنون)"
                value={tier.perUserOrderCountEndDate}
                onChange={(newDate) => handleChange(index, "perUserOrderCountEndDate", newDate)}
                showTime={true}
              />
            </div>
            <div className="p-3 bg-white border border-violet-100 rounded-lg space-y-3">
              <div>
                <p className="text-xs font-semibold text-gray-600 mb-2">فیلتر سطح نمایندگی (خالی = همه سطوح)</p>
                <div className={`flex gap-3 flex-wrap ${(tier.requiredUserIds || []).length > 0 ? "opacity-40 pointer-events-none" : ""}`}>
                  {["برنزی", "نقره ای", "طلایی"].map((level) => (
                    <label key={level} className={`flex items-center gap-2 px-3 py-1.5 rounded-lg border cursor-pointer text-sm font-medium transition-colors ${
                      (tier.requiredUserLevels || []).includes(level)
                        ? "bg-violet-100 border-violet-300 text-violet-700"
                        : "bg-white border-gray-200 text-gray-500 hover:bg-gray-50"
                    }`}>
                      <input
                        type="checkbox"
                        checked={(tier.requiredUserLevels || []).includes(level)}
                        onChange={(e) => {
                          const current = tier.requiredUserLevels || []
                          const next = e.target.checked
                            ? [...current, level]
                            : current.filter((l) => l !== level)
                          handleChange(index, "requiredUserLevels", next)
                        }}
                        className="hidden"
                      />
                      {level}
                    </label>
                  ))}
                </div>
              </div>
              <div className="border-t border-violet-100 pt-3">
                <div className="flex items-center justify-between mb-2">
                  <p className="text-xs font-semibold text-gray-600">یا آپلود لیست از اکسل (ستون «موبایل»)</p>
                  {(tier.requiredUserIds || []).length > 0 && (
                    <button
                      type="button"
                      onClick={() => handleChange(index, "requiredUserIds", [])}
                      className="text-xs text-red-500 hover:text-red-700 underline"
                    >
                      پاک کردن لیست
                    </button>
                  )}
                </div>
                {(tier.requiredUserIds || []).length > 0 ? (
                  <p className="text-sm text-violet-700 font-semibold">
                    ✓ {tier.requiredUserIds.length} کاربر بارگذاری شده (فیلتر سطح نادیده گرفته می‌شود)
                  </p>
                ) : (
                  <label className="flex items-center gap-2 px-3 py-2 rounded-lg border-2 border-dashed border-violet-200 cursor-pointer hover:border-violet-400 hover:bg-violet-50 transition-colors w-fit text-sm text-violet-600">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" /></svg>
                    آپلود فایل اکسل
                    <input
                      type="file"
                      accept=".xlsx,.xls"
                      onChange={handleExcelUploadForTier(index, handleChange)}
                      className="hidden"
                    />
                  </label>
                )}
              </div>
            </div>
          </div>
        ) : null}

        {tier.isOrderCountBased ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">حداقل تعداد سفارش</label>
              <input
                type="number"
                value={tier.minOrderCount ?? ""}
                onChange={(e) => handleChange(index, "minOrderCount", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
                placeholder="مثلاً 0"
                min="0"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">حداکثر تعداد سفارش (خالی = بدون حد)</label>
              <input
                type="number"
                value={tier.maxOrderCount ?? ""}
                onChange={(e) => handleChange(index, "maxOrderCount", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
                placeholder="مثلاً 50"
                min="0"
              />
            </div>
            <div>
              <DateInput
                label="تاریخ شروع شمارش"
                value={tier.orderCountStartDate}
                onChange={(newDate) => handleChange(index, "orderCountStartDate", newDate)}
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">درصد تخفیف</label>
              <input
                type="number"
                value={tier.discountPercent || ""}
                onChange={(e) => handleChange(index, "discountPercent", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
              />
            </div>
          </div>
        ) : tier.isItemCountBased ? null : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <div>
              <label className="block text-xs text-gray-500 mb-1">حداقل قیمت (تومان)</label>
              <input
                type="number"
                value={tier.minPrice || ""}
                onChange={(e) => handleChange(index, "minPrice", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">حداکثر قیمت (خالی = بدون محدودیت)</label>
              <input
                type="number"
                value={tier.maxPrice || ""}
                onChange={(e) => handleChange(index, "maxPrice", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
              />
            </div>
            <div>
              <label className="block text-xs text-gray-500 mb-1">درصد تخفیف</label>
              <input
                type="number"
                value={tier.discountPercent || ""}
                onChange={(e) => handleChange(index, "discountPercent", e.target.value)}
                className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-blue-400"
              />
            </div>
          </div>
        )}

        <div className="flex gap-4 flex-wrap">
          <label className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
            <input
              type="checkbox"
              checked={tier.isFreeShipping || false}
              onChange={(e) => handleChange(index, "isFreeShipping", e.target.checked)}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-700">ارسال رایگان</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
            <input
              type="checkbox"
              checked={tier.hasGift || false}
              onChange={(e) => handleChange(index, "hasGift", e.target.checked)}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-700">دارای هدیه</span>
          </label>
          <label className="flex items-center gap-2 cursor-pointer px-3 py-2 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors">
            <input
              type="checkbox"
              checked={tier.noVisualDiscount || false}
              onChange={(e) => handleChange(index, "noVisualDiscount", e.target.checked)}
              className="w-4 h-4"
            />
            <span className="text-sm text-gray-700">بدون خط‌خوردگی روی محصولات</span>
          </label>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
          <div className="p-3 bg-gray-50 border border-gray-200 rounded-xl">
            <p className="text-xs font-semibold text-gray-500 mb-2.5">محدودیت نقش</p>
            <div className="space-y-2">
              {[
                { value: "customer", label: "مشتری" },
                { value: "seller", label: "فروشنده" },
                { value: "affiliate", label: "نماینده" },
                { value: "sub_affiliate", label: "زیرنماینده" },
              ].map((role) => (
                <label key={role.value} className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={(tier.roles || []).includes(role.value)}
                    onChange={(e) => {
                      const currentRoles = tier.roles || [];
                      const newRoles = e.target.checked
                        ? [...currentRoles, role.value]
                        : currentRoles.filter((r) => r !== role.value);
                      handleChange(index, "roles", newRoles);
                    }}
                    className="w-4 h-4"
                  />
                  <span className="text-sm text-gray-600">{role.label}</span>
                </label>
              ))}
            </div>
            <p className="text-xs text-gray-400 mt-2">
              {(tier.roles || []).length === 0 ? "همه نقش‌ها" : `${tier.roles.length} نقش`}
            </p>
          </div>

          <div className="p-3 bg-gray-50 border border-gray-200 rounded-xl">
            <p className="text-xs font-semibold text-gray-500 mb-2.5">محدودیت زمانی</p>
            <div className="space-y-2">
              <DateInput
                label="شروع"
                value={tier.startDateTime}
                onChange={(newDate) => handleChange(index, "startDateTime", newDate)}
                showTime={true}
              />
              <DateInput
                label="پایان"
                value={tier.endDateTime}
                onChange={(newDate) => handleChange(index, "endDateTime", newDate)}
                showTime={true}
              />
            </div>
            <p className="text-xs text-gray-400 mt-2">
              {!tier.startDateTime && !tier.endDateTime ? "بدون محدودیت" : "محدود به بازه زمانی"}
            </p>
          </div>

          <div className="p-3 bg-gray-50 border border-gray-200 rounded-xl">
            <p className="text-xs font-semibold text-gray-500 mb-2.5">استثناها</p>
            <div className="space-y-2">
              <CategoriesSelect
                key={`tier-excluded-categories-${tier._tempId || tier._id || index}`}
                label="دسته‌بندی"
                oldCategory={(tier.excludedCategories || []).map(id => ({ _id: id }))}
                onChange={(categoryIds) => handleChange(index, "excludedCategories", categoryIds)}
              />
              <ProductsSelect
                key={`tier-excluded-products-${tier._tempId || tier._id || index}`}
                label="محصول"
                oldProducts={tier.excludedProductSkus || []}
                onChange={(skus) => handleChange(index, "excludedProductSkus", skus)}
              />
            </div>
            <p className="text-xs text-gray-400 mt-2">
              {(tier.excludedCategories?.length || 0) + (tier.excludedProductSkus?.length || 0) === 0
                ? "بدون استثنا"
                : `${tier.excludedCategories?.length || 0} دسته، ${tier.excludedProductSkus?.length || 0} محصول`}
            </p>
          </div>
        </div>

        {tier.hasGift && (
          <div className="space-y-3 pt-1">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
              <div>
                <label className="block text-xs text-gray-500 mb-1">نوع هدیه</label>
                <select
                  value={tier.giftType || "fixed"}
                  onChange={(e) => handleChange(index, "giftType", e.target.value)}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
                >
                  <option value="fixed">ثابت</option>
                  <option value="choice">انتخابی</option>
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">حداقل قیمت برای هدیه (تومان)</label>
                <input
                  type="number"
                  value={tier.minPriceForGift || ""}
                  onChange={(e) =>
                    handleChange(index, "minPriceForGift", e.target.value ? Number(e.target.value) : undefined)
                  }
                  placeholder="مثلاً 1500000"
                  className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm"
                />
              </div>
              <div>
                <ProductsSelect
                  key={`tier-products-${tier._tempId || tier._id || index}`}
                  label={tier.giftType === "choice" ? "گزینه‌های هدیه انتخابی" : "محصولات هدیه ثابت"}
                  oldProducts={tier.giftProductSkus || []}
                  onChange={(skus) => handleChange(index, "giftProductSkus", skus)}
                />
              </div>
              <div>
                <ProductsSelect
                  key={`tier-additional-gifts-${tier._tempId || tier._id || index}`}
                  label="محصولات هدیه ثابت اضافی"
                  oldProducts={tier.additionalFixedGiftSkus || []}
                  onChange={(skus) => handleChange(index, "additionalFixedGiftSkus", skus)}
                />
              </div>
            </div>
          </div>
        )}

        <div className="border border-gray-200 rounded-xl p-3 bg-gray-50/50">
          <div className="flex items-center justify-between mb-3">
            <div>
              <span className="text-sm font-semibold text-gray-700">تخفیف ویژه گروه‌های محصول</span>
              <p className="text-xs text-gray-400 mt-0.5">
                محصولاتی که تخفیف متفاوتی نسبت به تخفیف پایه دارند را اینجا تعریف کنید
              </p>
            </div>
            <button
              type="button"
              onClick={() => {
                const newGroups = [...(tier.productGroupDiscounts || []), {
                  _tempId: Date.now(),
                  name: "",
                  skus: [],
                  discountPercent: 0,
                }];
                handleChange(index, "productGroupDiscounts", newGroups);
              }}
              className="flex items-center gap-1 text-xs font-medium text-gray-600 hover:text-gray-900 bg-white border border-gray-300 rounded-lg px-2.5 py-1.5 transition-colors hover:bg-gray-100 whitespace-nowrap"
            >
              <PiPlus size={13} />
              افزودن گروه
            </button>
          </div>

          {(tier.productGroupDiscounts || []).length === 0 ? (
            <p className="text-xs text-gray-400 text-center py-2">
              بدون تخفیف ویژه — همه محصولات تخفیف پایه ({tier.discountPercent || 0}٪) می‌گیرند
            </p>
          ) : (
            <div className="space-y-2">
              {(tier.productGroupDiscounts || []).map((group, gIdx) => (
                <div
                  key={group._tempId || group._id || gIdx}
                  className="border border-gray-200 rounded-lg p-3 bg-white"
                >
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs font-medium text-gray-500">گروه {gIdx + 1}</span>
                    <button
                      type="button"
                      onClick={() => {
                        const newGroups = (tier.productGroupDiscounts || []).filter((_, i) => i !== gIdx);
                        handleChange(index, "productGroupDiscounts", newGroups);
                      }}
                      className="p-1 rounded text-gray-300 hover:text-red-400 hover:bg-red-50 transition-colors"
                    >
                      <PiTrash size={14} />
                    </button>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">نام گروه</label>
                      <input
                        type="text"
                        value={group.name || ""}
                        onChange={(e) => {
                          const newGroups = [...(tier.productGroupDiscounts || [])];
                          newGroups[gIdx] = { ...group, name: e.target.value };
                          handleChange(index, "productGroupDiscounts", newGroups);
                        }}
                        placeholder="مثلاً: شامپوهای ویژه"
                        className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:border-gray-400"
                      />
                    </div>
                    <div>
                      <label className="block text-xs text-gray-500 mb-1">درصد تخفیف این گروه</label>
                      <input
                        type="number"
                        value={group.discountPercent ?? ""}
                        onChange={(e) => {
                          const newGroups = [...(tier.productGroupDiscounts || [])];
                          newGroups[gIdx] = { ...group, discountPercent: e.target.value === "" ? 0 : Number(e.target.value) };
                          handleChange(index, "productGroupDiscounts", newGroups);
                        }}
                        min="0"
                        max="100"
                        className="w-full border border-gray-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:border-gray-400"
                      />
                    </div>
                    <div className="flex items-center text-xs pt-5">
                      {group.discountPercent > (tier.discountPercent || 0) ? (
                        <span className="text-emerald-600">↑ بیشتر از پایه</span>
                      ) : group.discountPercent < (tier.discountPercent || 0) ? (
                        <span className="text-rose-400">↓ کمتر از پایه</span>
                      ) : (
                        <span className="text-gray-300">= برابر پایه</span>
                      )}
                    </div>
                  </div>
                  <div className="mt-2">
                    <ProductsSelect
                      key={`group-products-${tier._tempId || index}-${gIdx}`}
                      label="محصولات این گروه"
                      oldProducts={group.skus || []}
                      onChange={(skus) => {
                        const newGroups = [...(tier.productGroupDiscounts || [])];
                        newGroups[gIdx] = { ...group, skus };
                        handleChange(index, "productGroupDiscounts", newGroups);
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6 relative">
      <Title title={"مدیریت قسمت های وب سایت"} />
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu1: !accardionToggle.subMenu1,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>نمایندگان الماسی</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu1 && "hidden"}`}>
            <AffiliateRankCard
              data={data?.diamondAffiliateRank}
              field={"diamondAffiliateRank"}
            />
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu2: !accardionToggle.subMenu2,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>نمایندگان طلایی</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu2 && "hidden"}`}>
            <AffiliateRankCard
              data={data?.goldAffiliateRank}
              field={"goldAffiliateRank"}
            />
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu9: !accardionToggle.subMenu9,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>نمایندگان نقره‌ای</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu9 && "hidden"}`}>
            <AffiliateRankCard
              data={data?.silverAffiliateRank}
              field={"silverAffiliateRank"}
            />
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu3: !accardionToggle.subMenu3,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تنظیمات کمپین</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu3 && "hidden"}`}>
            <div className="w-full py-5 px-4 border-r border-l border-b space-y-3">
              <div className="flex items-center justify-between p-4 rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-sm text-gray-800">کمپین عطارباشی</p>
                </div>
                <Button
                  text={campaignAttarbashiActive ? "غیرفعال کردن کمپین" : "فعال کردن کمپین"}
                  color={campaignAttarbashiActive ? "danger" : "success"}
                  onClick={handleCampaignAttarbashiToggle}
                />
              </div>

              <div className="flex items-center justify-between p-4 rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-sm text-gray-800">کمپین صبورا</p>
                </div>
                <Button
                  text={campaignSabooraActive ? "غیرفعال کردن کمپین" : "فعال کردن کمپین"}
                  color={campaignSabooraActive ? "danger" : "success"}
                  onClick={handleCampaignSabooraToggle}
                />
              </div>

              <div className="p-4 rounded-xl border border-gray-200 bg-white">
                <p className="font-semibold text-sm text-gray-800 mb-3">حالت هدف‌گیری کمپین</p>
                <div className="flex gap-2">
                  <label
                    className={`flex items-center px-3 py-1.5 rounded-lg border cursor-pointer text-xs font-medium transition-colors whitespace-nowrap ${
                      campaignTargetMode === "all"
                        ? "bg-blue-50 border-blue-300 text-blue-700"
                        : "bg-white border-gray-200 text-gray-400 hover:bg-gray-50"
                    }`}
                  >
                    <input
                      type="radio"
                      value="all"
                      checked={campaignTargetMode === "all"}
                      onChange={() => handleCampaignTargetModeChange("all")}
                      className="hidden"
                    />
                    عمومی — کمپین برای همه اجرا می‌شود
                  </label>
                  <label
                    className={`flex items-center px-3 py-1.5 rounded-lg border cursor-pointer text-xs font-medium transition-colors whitespace-nowrap ${
                      campaignTargetMode === "specific"
                        ? "bg-violet-50 border-violet-300 text-violet-700"
                        : "bg-white border-gray-200 text-gray-400 hover:bg-gray-50"
                    }`}
                  >
                    <input
                      type="radio"
                      value="specific"
                      checked={campaignTargetMode === "specific"}
                      onChange={() => handleCampaignTargetModeChange("specific")}
                      className="hidden"
                    />
                    اختصاصی — فقط برای نمایندگان/مشاوران مشخص
                  </label>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu4: !accardionToggle.subMenu4,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تنظیمات سطوح تخفیف کمپین</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu4 && "hidden"}`}>
            <div className="w-full py-6 px-4 border-r border-l border-b">
              <div className="mb-6">
                <h3 className="text-xl font-bold mb-4">سطوح تخفیف عطارباشی</h3>
                <div className="mb-4">
                  <Button
                    text="افزودن سطح جدید"
                    color="primary"
                    onClick={handleAddTierAttarbashi}
                    icon={<PiPlus />}
                  />
                </div>
                {campaignTiersAttarbashi.map((tier, index) => 
                  renderTier(tier, index, handleRemoveTierAttarbashi, handleTierChangeAttarbashi)
                )}
                {campaignTiersAttarbashi.length === 0 && (
                  <p className="text-gray-500 text-center py-4">هیچ سطحی برای عطارباشی تعریف نشده است</p>
                )}
              </div>

              <div className="mb-6 pt-6 border-t border-gray-300">
                <h3 className="text-xl font-bold mb-4">سطوح تخفیف صبورا</h3>
                <div className="mb-4">
                  <Button
                    text="افزودن سطح جدید"
                    color="primary"
                    onClick={handleAddTierSaboora}
                    icon={<PiPlus />}
                  />
                </div>
                {campaignTiersSaboora.map((tier, index) => 
                  renderTier(tier, index, handleRemoveTierSaboora, handleTierChangeSaboora)
                )}
                {campaignTiersSaboora.length === 0 && (
                  <p className="text-gray-500 text-center py-4">هیچ سطحی برای صبورا تعریف نشده است</p>
                )}
              </div>

              {(campaignTiersAttarbashi.length > 0 || campaignTiersSaboora.length > 0) && (
                <div className="mt-4">
                  <Button
                    text="ذخیره تنظیمات"
                    color="success"
                    onClick={handleSaveTiers}
                  />
                </div>
              )}

              <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-sm text-gray-700">
                  <strong>راهنما:</strong>
                </p>
                <ul className="text-sm text-gray-600 mt-2 list-disc list-inside space-y-1">
                  <li><strong>تخفیف بر اساس قیمت:</strong></li>
                  <li className="mr-4">خرید بالای 700 هزار تومان: ارسال رایگان</li>
                  <li className="mr-4">خرید بین 1 تا 2 میلیون: 10% تخفیف + هدیه + ارسال رایگان</li>
                  <li className="mr-4">خرید بالای 3 میلیون: 15% تخفیف + هدیه انتخابی + ارسال رایگان</li>
                  <li className="mt-2"><strong>تخفیف بر اساس تعداد سفارشات کل سیستم:</strong></li>
                  <li className="mr-4">50 سفارش اول: 15% تخفیف + ارسال رایگان (سفارش 0 تا 49)</li>
                  <li className="mr-4">بعد از 50 سفارش: 10% تخفیف + ارسال رایگان (سفارش 50 به بعد)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu5: !accardionToggle.subMenu5,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>تنظیمات پس کرایه صبورا</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu5 && "hidden"}`}>
            <div className="w-full py-6 px-4 border-r border-l border-b">
              <div className="mb-6">
                <h3 className="text-xl font-bold mb-4">مدیریت هزینه پس کرایه محصولات صبورا</h3>
                <div className="mb-4">
                  <Button
                    text="افزودن گروه جدید"
                    color="primary"
                    onClick={handleAddSabooraShipping}
                    icon={<PiPlus />}
                  />
                </div>
                <p className="text-sm text-gray-600 mb-4 bg-yellow-50 border border-yellow-200 p-3 rounded-lg">
                  💡 <strong>نکته:</strong> محصولاتی که شرایط یکسانی دارند (قیمت و نوع ارسال) را می‌توانید در یک گروه قرار دهید.
                </p>

                {sabooraShippingConfig.map((config, index) => (
                  <div
                    key={config._tempId || config._id || index}
                    className="border border-gray-200 rounded-lg p-4 mb-4 bg-gray-50"
                  >
                    <div className="flex justify-between items-center mb-4">
                      <div>
                        <span className="font-bold text-lg">گروه {index + 1}</span>
                        {config.skus && config.skus.length > 0 && (
                          <span className="text-sm text-gray-500 mr-2">
                            ({config.skus.length} محصول)
                          </span>
                        )}
                      </div>
                      <button
                        onClick={() => handleRemoveSabooraShipping(index)}
                        className="text-red-500 hover:text-red-700"
                      >
                        <PiTrash size={20} />
                      </button>
                    </div>

                    <div className="grid grid-cols-1 gap-4">
                      <div>
                        <ProductsSelect
                          key={`saboora-product-${config._tempId || config._id || index}`}
                          label="انتخاب محصولات صبورا (می‌توانید چند محصول مشابه را با هم انتخاب کنید)"
                          oldProducts={config.selectedProducts || []}
                          onChange={(skus) => handleSabooraShippingChange(index, "products", skus)}
                          brandFilter="saboora"
                          singleSelect={false}
                        />
                        {config.skus && config.skus.length > 0 && (
                          <div className="text-xs text-gray-600 mt-2">
                            <span className="font-bold">SKU های انتخاب شده:</span>
                            <div className="flex flex-wrap gap-2 mt-1">
                              {config.skus.map((sku, idx) => (
                                <span
                                  key={idx}
                                  className="bg-blue-100 text-blue-800 px-2 py-1 rounded-md font-mono"
                                >
                                  {sku}
                                </span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium mb-1">
                            هزینه پس کرایه (تومان) <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="number"
                            value={config.shippingPrice || ""}
                            onChange={(e) => handleSabooraShippingChange(index, "shippingPrice", e.target.value)}
                            className="w-full border rounded-lg p-2"
                            placeholder="مثال: 75000"
                            min="0"
                          />
                          <p className="text-xs text-gray-500 mt-1">
                            {(config.shippingPrice || 0).toLocaleString()} تومان
                          </p>
                        </div>

                        <div className="flex items-center gap-2 pt-6">
                          <input
                            type="checkbox"
                            checked={config.isDivisible || false}
                            onChange={(e) => handleSabooraShippingChange(index, "isDivisible", e.target.checked)}
                            className="w-5 h-5"
                          />
                          <label className="text-sm font-medium">
                            قابل تقسیم (هر 3 عدد = 1 واحد ارسال)
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {sabooraShippingConfig.length === 0 && (
                  <p className="text-gray-500 text-center py-4">
                    هیچ تنظیماتی برای پس کرایه صبورا تعریف نشده است
                  </p>
                )}

                {sabooraShippingConfig.length > 0 && (
                  <div className="mt-4">
                    <Button
                      text="ذخیره تنظیمات پس کرایه"
                      color="success"
                      onClick={handleSaveSabooraShipping}
                    />
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu7: !accardionToggle.subMenu7,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>خدمات سطح نمایندگی</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu7 && "hidden"}`}>
            <div className="w-full py-5 px-4 border-r border-l border-b space-y-3">
              <div className="flex items-center justify-between p-4 rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-sm text-gray-800">خدمات سطح عطارباشی</p>
                </div>
                <Button
                  text={affiliateLevelDiscountAttarbashi ? "غیرفعال کردن" : "فعال کردن"}
                  color={affiliateLevelDiscountAttarbashi ? "danger" : "success"}
                  onClick={handleAffiliateLevelDiscountAttarbashiToggle}
                />
              </div>
              <div className="flex items-center justify-between p-4 rounded-xl border border-gray-200 bg-white">
                <div className="flex items-center gap-3">
                  <p className="font-semibold text-sm text-gray-800">خدمات سطح صبورا</p>
                </div>
                <Button
                  text={affiliateLevelDiscountSaboora ? "غیرفعال کردن" : "فعال کردن"}
                  color={affiliateLevelDiscountSaboora ? "danger" : "success"}
                  onClick={handleAffiliateLevelDiscountSabooraToggle}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({
                ...accardionToggle,
                subMenu6: !accardionToggle.subMenu6,
              })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>استثناهای کمپین برای نمایندگان و مشاوران</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu6 && "hidden"}`}>
            <div className="w-full py-6 px-4 border-r border-l border-b">
              <CampaignRefExceptions
                initialExceptions={data?.campaignRefExceptions || []}
                onSaved={getPublicFieldData}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <div id="accordion-collapse" data-accordion="collapse">
          <h2
            onClick={() =>
              setAccardionToggle({ ...accardionToggle, subMenu8: !accardionToggle.subMenu8 })
            }
          >
            <button
              type="button"
              className="flex items-center justify-between w-full p-5 font-medium rtl:text-right text-gray-500 border border-gray-200 dark:border-gray-700 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800 gap-3"
            >
              <span>مخفی‌سازی تخفیف برای نقش یا کاربر خاص</span>
              <PiArrowDownBold />
            </button>
          </h2>
          <div className={`${!accardionToggle.subMenu8 && "hidden"}`}>
            <div className="w-full py-6 px-4 border-r border-l border-b space-y-4">
              <p className="text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-lg p-3">
                کاربرانی که در این لیست هستند، هیچ تخفیفی روی محصولات نمی‌بینند — قیمت اصلی برایشان نمایش داده می‌شود.
              </p>

              <div className="border border-gray-200 rounded-xl p-4 bg-white">
                <p className="text-sm font-semibold text-gray-700 mb-3">مخفی کردن برای نقش‌های خاص</p>
                <div className="flex gap-3 flex-wrap">
                  {[
                    { value: "customer", label: "مشتری" },
                    { value: "affiliate", label: "نماینده" },
                    { value: "seller", label: "مشاور" },
                    { value: "sub_affiliate", label: "زیرنماینده" },
                  ].map((role) => (
                    <label
                      key={role.value}
                      className={`flex items-center gap-2 px-4 py-2 rounded-lg border cursor-pointer text-sm font-medium transition-colors ${
                        discountHiddenForRoles.includes(role.value)
                          ? "bg-red-50 border-red-300 text-red-700"
                          : "bg-white border-gray-200 text-gray-500 hover:bg-gray-50"
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={discountHiddenForRoles.includes(role.value)}
                        onChange={(e) => {
                          setDiscountHiddenForRoles(
                            e.target.checked
                              ? [...discountHiddenForRoles, role.value]
                              : discountHiddenForRoles.filter((r) => r !== role.value)
                          );
                        }}
                        className="hidden"
                      />
                      {discountHiddenForRoles.includes(role.value) ? "✕ " : ""}{role.label}
                    </label>
                  ))}
                </div>
                {discountHiddenForRoles.length > 0 && (
                  <p className="text-xs text-red-500 mt-2">
                    تخفیف‌ها برای: {discountHiddenForRoles.join("، ")} مخفی می‌شود
                  </p>
                )}
              </div>

              <div className="border border-gray-200 rounded-xl p-4 bg-white">
                <p className="text-sm font-semibold text-gray-700 mb-3">مخفی کردن برای کاربران خاص</p>
                <AsyncSelect
                  cacheOptions={false}
                  defaultOptions
                  loadOptions={loadUsers}
                  value={discountHiddenUsers}
                  onChange={(opts) => setDiscountHiddenUsers(opts || [])}
                  placeholder="جستجو بر اساس موبایل یا نام..."
                  noOptionsMessage={() => "کاربری یافت نشد"}
                  loadingMessage={() => "در حال جستجو..."}
                  isMulti
                  isClearable
                />
                {discountHiddenUsers.length > 0 && (
                  <p className="text-xs text-red-500 mt-2">
                    {discountHiddenUsers.length} کاربر از دیدن تخفیف محروم هستند
                  </p>
                )}
              </div>

              <div>
                <Button text="ذخیره تنظیمات" color="success" onClick={handleSaveDiscountHiding} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
